function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { on, off } from 'view-design/src/utils/dom';
import { setMatchMedia } from 'view-design/src/utils/assist';
import { mapMutations, mapActions, mapGetters } from 'vuex';
setMatchMedia();
export default {
  name: 'app',
  provide: function provide() {
    return {
      reload: this.reload
    };
  },
  data: function data() {
    return {
      isRouterAlive: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('admin/global.v1', ['getUserInfo'])), {}, {
    getMobileStyle: function getMobileStyle() {
      var style = {};

      if (['limitApplicationMobile', 'creditApplicationMobile', 'limitApplication', 'creditApplication', 'largeOrderMobile', 'largeOrder', 'divideOrder', 'divideOrderMobile', 'zhiChiCommodity', 'zhiChiOrder', 'legalExaminationAndApproval', 'legalExaminationAndApprovalMobile'].includes(this.$route.name)) {
        style = {
          'min-width': 'initial'
        };
      }

      return style;
    }
  }),
  mounted: function mounted() {
    this.$Message.config({
      top: 400,
      duration: 2
    });
    on(window, 'resize', this.handleWindowResize);
    this.handleMatchMedia(); // 兼容IE浏览器URL地址栏改变后页面不发生变化

    this.ieRouterListener();
  },
  watch: {
    $route: function $route(oldVal, newVal) {
      var _this = this;

      if (oldVal.query.form == 'ld') {
        setTimeout(function () {
          _this.login({
            form: 'ld'
          }).then(function (userInfo) {
            if (userInfo) {
              console.log('单点登录成功');
            }
          });
        }, 50);
      }

      zc('config', {
        partnerid: util.cookies.get('auth-token'),
        params: JSON.stringify({
          orgClass: this.getUserInfo.orgClass,
          minSalesPrice: 0,
          maxSalesPrice: '',
          companyId: this.getUserInfo.companyId,
          userId: this.getUserInfo.userId,
          orgPath: this.getUserInfo.orgPath
        })
      });
      this.$nextTick(function () {
        zc('dynamic_ready');
      });
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations('admin/layout.ht', ['setDevice'])), mapActions('admin/global.v1', ['login'])), {}, {
    // test
    ieRouterListener: function ieRouterListener() {
      // 只在IE下执行
      // test
      // test1
      if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        window.addEventListener('hashchange', this.routerHashChange);
      }
    },
    // 冲突测试
    routerHashChange: function routerHashChange() {
      var currentPath = window.location.hash.slice(1);

      if (this.$route.path !== currentPath) {
        this.$router.push(currentPath); // 主动更改路由界面
      }
    },
    handleWindowResize: function handleWindowResize() {
      this.handleMatchMedia();
    },
    handleMatchMedia: function handleMatchMedia() {
      var matchMedia = window.matchMedia;

      if (matchMedia('(max-width: 600px)').matches) {
        this.setDevice('Mobile');
      } else if (matchMedia('(max-width: 992px)').matches) {
        this.setDevice('Tablet');
      } else {
        this.setDevice('Desktop');
      }
    },
    reload: function reload() {
      var _this2 = this;

      this.isRouterAlive = false;
      this.$nextTick(function () {
        _this2.isRouterAlive = true;
      });
    }
  }),
  beforeDestroy: function beforeDestroy() {
    off(window, 'resize', this.handleWindowResize);
    window.removeEventListener('hashchange', this.routerHashChange);
  }
};